<div class="tg-example-modal">
  <h1 mat-dialog-title>{{'wizzard.changeTG' | translate}}</h1>
  <div mat-dialog-content>
    <mat-form-field>
      <mat-select placeholder="Select Target Group" [(value)]="data.selected">
        @for (item of data.targetGroups; track item.id) {
          <mat-option [value]="item.id" >
            {{item.ageMask}}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>

  </div>
  <div mat-dialog-actions>
    <button mat-button (click)="onNoClick()">{{'organization.cancel' | translate}}</button>
    <button mat-button [mat-dialog-close]="data.selected" cdkFocusInitial>{{'organization.change' | translate}}</button>
  </div>
</div>

